module.exports = __webpack_public_path__ + "static/media/font-icon.3468489e.svg";